export const LEVEL = {
  success: 'success',
  error: 'error',
  info: 'info',
  warning: 'warning',
};

export const SHOW_MESSAGE = 'listeningMode/SHOW_MESSAGE';
export const DISMISS_MESSAGE = 'listeningMode/DISMISS_MESSAGE';
export const POP_MESSAGE = 'listeningMode/POP_MESSAGE';
